// web-vitals@4 wiring. v4 replaced the v2 get*(cb) API (getCLS/getFID/…) with
// on*(cb) reporters and — crucially — added onINP, the metric that supersedes
// FID as a Core Web Vital. v2 predated onINP, so the INP bucket in the
// perf-rollup could never fill from the client; wiring onINP here is the point
// of this upgrade (review P2).
//
// FID is DEPRECATED (Google retired it as a Core Web Vital in favor of INP,
// 2024). We KEEP onFID for now so the /telemetry/perf 'fid' bucket keeps
// filling during the INP transition and historical dashboards stay continuous —
// a dual-report window. REMOVAL PLAN: once the backend PERF_METRICS set drops
// 'fid' (and the perfMetrics.js mirror + its mapper follow), delete the onFID
// line below. onFID is still exported by web-vitals@4, so it is safe until then.
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFID, onFCP, onINP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFID(onPerfEntry); // DEPRECATED — dual-reported with INP; see removal plan above.
      onFCP(onPerfEntry);
      onINP(onPerfEntry); // supersedes FID as the responsiveness Core Web Vital.
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
